import * as Immutable from "immutable";
import transformInaccessibleFilters from "search-filter/logic/transformInaccessibleFilters";
import createSearch from "views/logic/slices/createSearch";
const transformInaccessibleFiltersInSearchTypes = (queries, userPermissions) => queries.map((query) => {
  const updatedSearchTypes = query.searchTypes.map((searchType) => ({
    ...searchType,
    filters: transformInaccessibleFilters(Immutable.List(searchType.filters), userPermissions).toArray()
  }));
  return query.toBuilder().searchTypes(updatedSearchTypes).build();
});
const transformInaccessibleFiltersInWidgets = (viewStates, userPermissions) => viewStates.map((viewState) => {
  const updatedWidgets = viewState.widgets.map((widget) => {
    const updatedFilters = transformInaccessibleFilters(widget.filters, userPermissions);
    return widget.toBuilder().filters(Immutable.List(updatedFilters)).build();
  });
  return viewState.toBuilder().widgets(updatedWidgets.toList()).build();
});
const transformInaccessibleFiltersInDashboard = async (view, userPermissions) => {
  const updatedQueries = transformInaccessibleFiltersInSearchTypes(view.search.queries, userPermissions);
  const newViewState = transformInaccessibleFiltersInWidgets(view.state, userPermissions);
  const newSearchWithNewId = await createSearch(view.search.toBuilder().queries(updatedQueries.toSet()).build());
  return view.toBuilder().search(newSearchWithNewId).state(newViewState.toMap()).build();
};
export default transformInaccessibleFiltersInDashboard;
